const TOKEN_KEY = 'EDU_OS_TOKEN';
const REDIRECT_KEY = 'EDU_REDIRECT_AFTER_LOGIN';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) ?? '';
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function setRedirectPath(path: string) {
  localStorage.setItem(REDIRECT_KEY, path);
}

export function getRedirectPath() {
  return localStorage.getItem(REDIRECT_KEY) ?? '';
}

export function clearRedirectPath() {
  localStorage.removeItem(REDIRECT_KEY);
}
